import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import PatientDetailResponseModel from "../../../models/API/responseModels/patientDetailResponse.model";

function usePatientDetail(
  id: string
): UseQueryResult<PatientDetailResponseModel> {
  const authState = useOktaAuth()?.authState;
  return useQuery({
    queryKey: ["patientDetail", { id }],
    queryFn: ({ queryKey }:any) =>
      axiosInstance
        .get(`/v1/patients/${queryKey[1]?.id}`, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken && !!id,
    refetchOnWindowFocus:false,
    retry: false,
  });
}

export default usePatientDetail;
